<template>
  <cube-popup
    ref="dailog"
    type="new-feature-popup"
  >
    <div class="my-title-img" />
    <div class="new-feature-box">
      <cube-scroll :data="[newFeatureInfo]">
        <div
          class="new-content"
          v-html="newFeatureInfo"
        />
      </cube-scroll>
    </div>
    <div
      class="cube-dialog-btns"
      @click="hideDialog"
    >
      我知道了
    </div>
  </cube-popup>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('newFeature', ['newFeatureInfo'])
  },
  methods: {
    showDialog () {
      this.$refs.dailog.show()
    },
    hideDialog () {
      this.$refs.dailog.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
  .new-feature-box {
    height: 192px;
    margin: 16px 0
  }
  .new-content{
    padding: 0 16px 0 28px;
  }
</style>
<style lang="scss">
.cube-new-feature-popup {
  .cube-popup-content {
    width: 300px;
    background: #fff;
    border-radius: 8px;
     .my-title-img {
      background: url(../../assets/images/img-new1.png) no-repeat 0 0;
      background-size: 300px;
      height: 60px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    .cube-dialog-btns {
      border-top: 1px solid #ddd;
      font-size: 18px;
      color: #5077AA;
      text-align: center;
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>
